(() => {
  if (window.merooBrandFilmsReady) return;
  window.merooBrandFilmsReady = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection;

  function initialize(root = document) {
    root.querySelectorAll('[data-meroo-films] video').forEach((video) => {
      if (video.dataset.filmReady) return;
      video.dataset.filmReady = 'true';
      const heading = video.closest('.meroo-film')?.querySelector('h3');
      if (heading) video.setAttribute('aria-labelledby', heading.id);
      // Native controls remain available even when JavaScript or autoplay fails.
      video.controls = true;
      let inView = false;
      let userPaused = false;
      let automaticPause = false;
      let playPending = false;

      const pause = () => {
        if (video.paused) return;
        automaticPause = true;
        video.pause();
      };
      const canAutoplay = () => inView && !document.hidden && !reducedMotion.matches && !connection?.saveData && !userPaused;
      const update = () => {
        if (!canAutoplay()) {
          pause();
          return;
        }
        if (!video.paused || playPending) return;
        playPending = true;
        Promise.resolve(video.play()).then(() => {
          if (!canAutoplay()) pause();
        }).catch(() => {
          // The poster and native play button are the fallback for blocked playback.
        }).finally(() => { playPending = false; });
      };
      video.addEventListener('pause', () => {
        if (!automaticPause) userPaused = true;
        automaticPause = false;
      });
      video.addEventListener('play', () => { userPaused = false; });

      // Without IntersectionObserver, leave playback under the customer's control.
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
        inView = entries[0].isIntersecting;
        update();
      }, { threshold: 0.2 }) : null;
      observer?.observe(video);
      document.addEventListener('visibilitychange', update);
      reducedMotion.addEventListener('change', update);
      connection?.addEventListener('change', update);
      const section = video.closest('.shopify-section');
      section?.addEventListener('shopify:section:unload', () => {
        inView = false;
        pause();
        observer?.disconnect();
        document.removeEventListener('visibilitychange', update);
        reducedMotion.removeEventListener('change', update);
        connection?.removeEventListener('change', update);
      }, { once: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
